import React, { useEffect } from "react";
import "./index.css";
import { Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

// 🌐 Global Pages
import LandingPage from "./pages/LandingPage";
import M2TPricingPage from "./pages/M2TPricingPage";
import NewsPage from "./pages/NewsPage";
import Investorindex from "./pages/InvestorsPage/Investorindex";
import WelcomePage from "./components/Dashboard/TraderDashboard/WelcomePage";
import FAQ from "./pages/documents/public-pages/HelpSupport/FAQ";
import WaitlistSignup from "./components/common/WaitlistSignup";
import PartnerSignup from "./components/common/PartnerSignup";

// 🏢 Dashboard Pages
import DashboardRoutes from "./routes/DashboardRoutes";

// 📚 Blog, Company, Legal Routes
import blogRoutes from "./routes/BlogRoutes";
import companyRoutes from "./routes/CompanyRoutes";
import legalRoutes from "./components/Legal/legalRoutes";

// 🛠️ Utility
import ScrollToTop from "./components/common/ScrollToTop";

import SubHeader from "./components/LandingPage/SubHeader";
import MarketTicker from "./components/LandingPage/MarketTicker";
import Addyourroles from "./components/LandingPage/AddYourRoles";
import AdminChatDashboard from "./components/Chat/AdminChatDashboard";
import SmartCardPersonal from "./pages/SmartCardPersonalPreview";
import SmartCardBusiness from "./pages/SmartCardBusinessPreview";
import Directory from "./pages/Directory";
import Community from "./pages/Community";
import VerifyEmail from "./modules/auth/VerifyEmail";

import SocialMediaWall from "./components/Product-zone/SocialMediaWall";
import SocialConnectHub from "./components/Product-zone/SocialConnectHub";

// ✅ Product zones
import Products from "./pages/products/Productzones";
import ProductLandingPage from "./components/Product-zone/Product-landing/ProductLandingPage";
import Solutions from "./components/Company/Solutions";
import FeedContainer from "./components/Feed/FeedContainer";

// ✅ Google Analytics Listener
function GAListener() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="relative min-h-screen w-full bg-black text-white">
      <style>{`
        html, body, * { cursor: auto !important; }
      `}</style>

      <ScrollToTop />
      <GAListener />

      <div className="container mx-auto px-0">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/investors" element={<Investorindex />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/addyourroles" element={<Addyourroles />} />
          <Route path="/admin/chat" element={<AdminChatDashboard />} />
          <Route path="/smartcard-personal" element={<SmartCardPersonal />} />
          <Route path="/smartcard-business" element={<SmartCardBusiness />} />
          <Route path="/subheader" element={<SubHeader />} />
          <Route path="/ticker" element={<MarketTicker />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/community" element={<Community />} />
          <Route path="/waitlist" element={<WaitlistSignup />} />
          <Route path="/partner-signup" element={<PartnerSignup />} />
          <Route path="/verify" element={<VerifyEmail />} />
          <Route path="/pricing" element={<M2TPricingPage />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/productzones" element={<Products />} />
          <Route path="/ProductLandingPage" element={<ProductLandingPage />} />
          <Route path="/SocialMediaWall" element={<SocialMediaWall />} />
          <Route path="/feed" element={<FeedContainer />} />
          <Route
            path="/social-connect-hub"
            element={<SocialConnectHub userEmail="mrkumarevents@gmail.com" />}
          />

          {DashboardRoutes}

          {blogRoutes.map((route, idx) => (
            <Route key={idx} path={route.path} element={route.element} />
          ))}

          {companyRoutes}

          {legalRoutes.map((route, idx) => (
            <Route key={idx} path={route.path} element={route.element} />
          ))}

          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
